import EventHandler from 'bootstrap/js/src/dom/event-handler.js';
import SelectorEngine from 'bootstrap/js/src/dom/selector-engine.js';

const EVENT_SLID        = 'slid.bs.carousel';
const SELECTOR_CAROUSEL = '.carousel';
const SELECTOR_CAPTION  = '.carousel-caption-container p';

const instances = new WeakMap();

class CarouselCaption {
  constructor(element) {
    this._element   = element;
    this._captionEl = element.querySelector(SELECTOR_CAPTION) || null;
    this._updateCaption();
    instances.set(element, this);
  }

  _updateCaption() {
    if (!this._captionEl) return;
    const activeItem = SelectorEngine.findOne('.carousel-item.active', this._element);
    this._captionEl.textContent = activeItem?.getAttribute('data-caption') ?? '';
  }

  static getOrCreateInstance(element) {
    return instances.get(element) || new CarouselCaption(element);
  }
}

EventHandler.on(document, EVENT_SLID, SELECTOR_CAROUSEL, function () {
  CarouselCaption.getOrCreateInstance(this)._updateCaption();
});

export default CarouselCaption;
